import { useEffect, useRef, useState } from 'react';

import Tooltip from '@/shared/components/atoms/Tooltip';
import { ITooltipProps } from '@/shared/components/atoms/Tooltip/ITooltip';

const TooltipWithClick: React.FC<ITooltipProps> = ({
  content,
  children,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (target === null) return;
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(target) &&
        !target.closest('.tooltip-trigger')
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div>
      <Tooltip
        content={
          <div
            ref={tooltipRef}
            onClick={() => {
              setIsOpen(false);
            }}
          >
            {content}
          </div>
        }
        trigger={isOpen}
        onHover={false}
        {...props}
      >
        <span
          className='tooltip-trigger cursor-pointer text-primary-default'
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {children}
        </span>
      </Tooltip>
    </div>
  );
};

export default TooltipWithClick;
